module.exports = __webpack_public_path__ + "static/img/logo2.2c37e1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2.png
// module id = 708
// module chunks = 1